export default __webpack_public_path__ + "static/media/PDF.a6a1355c.pdf";